import React from 'react'
import { authRoles } from '../../auth/authRoles'

const TemplateRoutes = [

    {
        path: '/theme_component',
        component: React.lazy(() => import('./ThemeComponent')),
        auth: authRoles.dashboard,
    },
    
  
]

export default TemplateRoutes
